module.exports = {
  // Public screen
  community: "コミュニティ",
  event: "イベント",
  report: "レポート",
  post: "投稿",
  see_more: "もっと見る",
  group: "グループ",
  user: "ユーザー",
  sort: "並び替え",
  load_more: "さらにロード",
  yes: "はい",
  no: "いいえ",
  next: "つぎへ",
  close: "閉じる",
  back: "もどる",
  back_kanji: "戻る",
  decide: "決定",
  cancel: "キャンセル",
  notice: "注意事項",
  edit: "編集",
  required: "（必須）",
  optional: "（任意）",
  start_date: "開始日",
  end_date: "終了日",
  nickname: "ニックネーム",
  real_name: "本名",
  anonymous: "匿名",
  search: "検索",
  vote: "投票する",
  apply: "申し込む",
  other: "その他",
  member: "メンバー ",
  finish: "完了する",
  correct: "修正する",
  send: "送信する",
  confirm: "確定",

  home: "ホーム",
  opinion_plaza: "意見ひろば",
  everyone_post: "みんなの投稿",
  mypage: "マイページ",
  save: "保存",
  loading: "読み込み中",
  upgrade_to_regular_account: "めぶくIDへアップグレード！",
  parentheses_with_corner: "【{0}{1}】",
  colon: "：",

  member_role: "メンバー",
  leader: "リーダー",
  sub_leader: "サブリーダー",
  finance: "会計",
  waiting_approval: "承認待ち",
  payment_pending: "支払い保留中",
  denied: "拒否されました",

  no_name: "実名未設定",
  no_nickname: "ニックネーム未設定",

  agree: "同意して進む",

  // multi menu
  see_posts: "投稿を見る",
  chats: "チャットする",
  send_private_post: "プライベート投稿を送る",
  switch_role: "役割を変更する",
  kick: "強制退会させる",
  see_group_top_page: "グループトップを見る",
  execute_block: "ブロックする",
  execute_unblock: "ブロックを解除する",
  execute_report: "報告する",

  // home
  personal_info_popup_message: "めぶくコミュニティはより安全な環境を提供する為、個人情報のご提供が必要となります。「つぎへ」ボタンで画面が切り替わりますので画面にそってお進みください。",

  // my page
  mypage_default_description: "紹介文を入れられます。",
  mypage_description_label: "紹介文を入力して下さい",
  mypage_description_message: "紹介文を入力する",
  mypage_logout: "Logout",
  mypage_add_personal_plan: "予定を追加する",
  mypage_personal_plan_website: "【WEBサイト】",
  mypage_opinion_post: "意見広場・みんなの投稿",
  comment_history: "コメント履歴",
  mypage_questionnaire: "アンケート",
  private_post: "プライベート投稿",
  chat: "チャット",
  chat_list: "チャットリスト",
  mypage_create_member_group: "新しく作る",
  mypage_search: "探す",
  mypage_join_member_group_by_invitation_link: "招待リンクからグループに参加する",
  mypage_join_member_group_by_qr_code: "QRコードでグループに参加する",
  invited: "招待されました",
  payment: "お支払い関係",
  mypage_pay_to_group: "グループに支払う",
  mypage_reimbursement_history: "立て替え精算履歴",
  mypage_join_member_group_rejected: "恐れ入りますが、参加可能人数に達したなどの理由によりグループに参加できませんでした。",

  // post
  post_category: "カテゴリー",
  title: "タイトル",
  details: "本文",
  post_tag: "タグ",
  post_file: "ファイル",
  post_image: "画像",
  upload_images: "画像のアップロード",
  upload_images_notice: "最大5枚（5MB/枚）",
  upload_attachments: "ファイルのアップロード",
  upload_attachments_notice: "最大5ファイル（30MB/ファイル）",
  upload_attachments_description: "PDF、パワーポイント、エクセルなどのファイルをアップロードできます。",
  select_libraries: "ライブラリから選ぶ",
  select_samples: "サンプルから選ぶ",
  select_attachments: "ファイルを選ぶ",
  vote_question: "投票したい質問",
  add_vote_option: "回答を追加する",
  select_accept_comments: "コメントを受け付けますか？",
  post_notes_1: "ターゲットを絞った誹謗中傷の内容ではありません。",
  post_notes_2: "わいせつ行為や犯罪を促進する内容及び募集ではありません。",
  post_notes_3: "投稿内容に責任を持ちます。",
  agreement_post_notice: "上記の注意事項を確認し、すべての事項に同意致します。",
  post_save_success: "投稿が作成されました。",
  select_post_type: "投稿の種類を選んでください。",
  edit_post: "投稿を編集",
  inside_group_post: "グループ内の投稿",
  group_private_post: "グループ内のプライベート投稿",
  event_post: "イベント投稿",
  only_registered_app_user_can_create: "登録ユーザーのみが投稿を作成できます。",
  can_participant: "このイベント設定に参加できる人",
  can_participant_description: "公開グループの場合はイベント投稿が公開されます。グループメンバーでない人がイベントに応募しようとした場合、グループへの参加を促すメッセージが表示されます。",
  post_vote_question: "投票質問",
  post_vote_option: "投票内容",
  event_term: "イベント開催日・期間",
  end_date_description: "（開催日と異なる場合は記入）",
  application_start_date: "応募開始日",
  application_end_date: "応募終了日",
  select_date: "日付の選択",
  event_location: "イベント会場",
  venue_name: "会場名",
  postal_code: "郵便番号",
  postal_code_placeholder: "（0000000）",
  address: "住所",
  participation_item_name: "参加項目名",
  participation_fee: "参加料金",
  number_of_participants: "参加人数",
  select_post_name: "投稿名を選んでください。",
  post_name_description: "匿名を選択した場合「匿名」と表示されます。",
  submit_post: "投稿する",
  cancel_event: "イベントを中止する",
  error_min_vote_option_count: `投票内容は{0}つ以上設定してください。`,
  error_max_vote_option_count: `投票内容は{0}つまで設定できます。`,
  error_postal_code: "{0}文字以上は入力できません。",
  error_validate_postal_code: "{0}文字入力してください。",
  url: "WEBサイトのURL",
  url_placeholder: "[公式サイト]&#13;https://www.abc.com",
  error_file_count: "ファイルは{0}つまで選択可能です。{0}つを超えるファイルは選択できません。",
  error_post_tag: "重複したタグは設定できません。",
  postal_code_is_invalid: "郵便番号の形式が正しくありません。",
  blocking: "ブロックしています",

  all: "全て",
  tab_component_all_description: "全ての投稿です。",
  tab_component_community_description: "気になることや、伝えたいことなどの投稿です。",
  tab_component_event_description: "イベント情報、お祭り情報などの投稿です。",
  tab_component_report_description: "行ってみた、体験してきたなどのレポートです。",

  approved_post: "掲載中",
  rejected_post: "修正待ち",
  reported_post: "報告",
  post_in_process_of_judging: "審査中",
  can_view_post_user_count: "この投稿を見られるユーザー：{0}名",
  view_users: "ユーザーを見る",
  view_detail: "詳細を見る",
  is_already_applied: "申し込み済みです",
  is_already_requested_to_cancel: "キャンセル・参加費の返金をリクエスト済みです。参加費の返金をもって、キャンセルが完了になります。",
  read_more: "続きを読む",
  shrink_display: "表示を少なくする",

  // post history
  everyones_post_history: "「みんなの投稿」履歴",
  likes_count: "いいね！{0}件",
  see_more_text: "･･･続きを読む",

  // post report
  report_default_reason: "投稿内容に不適切な内容が含まれているため。",
  reported: "報告しました。",
  tell_reason_why_this_user_is_reported: "このユーザーを報告する理由を教えてください。",
  report_placeholder: "差し支えなければ通報する理由をお書きください",

  // group private post
  select_users: "ユーザーの選択",
  can_search_for_users: "ユーザーを検索できます。",
  members_with_roles: "役割を持っているメンバー",

  // private post
  post_type_open: "オープン投稿",
  open_post_description: "投稿された内容は「みんなの投稿」に表示されます。",
  private_post_description: "投稿された内容は指定したユーザーだけが見ることができます。学校、会社、友達など内輪で決め事をする際プライベート投稿は便利です。",
  post_private_users: "この投稿を見られるユーザー",
  add_users: "[＋] ユーザーを追加する",
  add_users_text: "ユーザーを追加する",

  view_post_user_deleted: "ユーザーを削除しました。",
  view_post_user_confirm_delete: "この投稿を見られるユーザーを削除しますか？",

  add_user_added: "ユーザーを追加しました。",
  add_user_cannot_add: "ユーザーを追加できませんでした。",
  group_member: "グループメンバー",
  add_user_search_users: "ユーザーを検索",

  // vote setting
  vote_setting: "投票を設定しますか？",
  vote_question_placeholder: "犬と猫どちらが好きですか？",
  vote_option_label: "回答0{0}",
  vote_option_placeholder_0: "犬派",
  vote_option_placeholder_1: "猫派",
  vote_option_placeholder_2: "両方好き",
  vote_end_date: "投票終了日 &nbsp;",
  vote_end_date_description: "最大３ヶ月先まで。",

  // event application
  participation_item_number: "参加項目名：{0}",
  participation_placeholder: "大人",
  unit_person: "人",
  free: "無料",
  unit_yen: "円",
  add_participation_item: "参加項目を追加する",
  delete_participation_item: "参加項目を削除する",
  application_button_settings: "応募ボタンを設置しますか？",
  not_set_applcation_button: "設置しない。",
  not_set_applcation_button_description: "誰でも何人でも参加できるイベントです。",
  set_applcation_button: "設置する：先着順",
  set_applcation_button_description_1: "参加人数の制限があるイベントです。",
  set_applcation_button_description_2: "選考は先着順です。",
  set_applcation_button_description_3: "参加料がある場合は参加申し込み時にお支払いとなります。",
  set_applcation_button_description_4: "参加人数に達成後、ボタンは押せなくなります。",
  cancellation_of_application: "【申し込み後のキャンセルについて】",
  can_cancel_and_refund: "キャンセルおよび返金可能",

  event_application_detail_information: "イベント情報",
  event_application_detail_host: "主催者（送金先）",
  event_name: "イベント名",
  event_application_application_term: "募集期間",
  participant_settings: "参加項目",
  event_application_number_of_persons: "募集人数 : {0}人",

  // post sort
  sort_by_new: "投稿日が新しい順",
  sort_by_old: "投稿日が古い順",
  sort_by_most_comments: "コメントが多い順",
  sort_by_least_comments: "コメントが少ない順",

  // post group filter
  clear_filter: "フィルターリセット",

  // opinion post filter
  vote_in_session: "開催中",
  vote_expired: "終了",

  // suggestion box
  suggestion_thank: "ご意見をご提出いただきありがとうございます。",
  suggestion_box: "意見箱",
  suggestion_description_1: "気になること、みんなの意見を聞いてみたいこと、議論してみたいことなどを自由にご記入してください。",
  suggestion_description_2: "集まった内容をめぶくコミュニティのナビゲーターが確認し、意見ひろばにて投稿します。",
  suggestion_description_3: "・ご記入いただいても直ぐには投稿されません。",
  suggestion_description_4: "・全ての意見が意見ひろばに投稿される訳ではございません。",
  suggestion_only_regular_app_user: "登録ユーザーのみが提案を行うことができます",

  facilitator_list_create_suggestion: "意見箱に意見を入れる",
  facilitator_list_description: "意見箱に寄せられた取り上げてほしい内容や議論をしたい内容をハンドラーがピックアップしました。気になる内容がありましたら積極的に意見交換をしてみましょう。",

  scan_group_qr_read_qr: "グループのQRコードを読み込んでください。",
  scan_group_qr_description: "QRコードを読み込むと、グループトップページからグループに参加できます。",

  // vote
  view_voting_status: "投票状況を見る",

  // comment
  comment: "コメント",
  comment_notice: "相手のことを考え丁寧なコメントを心がけて下さい。不快や攻撃的な言葉づかいなどは掲載を削除させていただくことがあります。",
  comment_reply: "返信する",
  comment_placeholder: "返信を書いてください...",
  read_comments: "コメント{0} 件を読む",

  //personal plan
  personal_plan_name: "予定名",
  personal_plan_error_date_after: "{0}には{1}以降の日付を設定してください。",
  personal_plan_date: "予定日",
  personal_plan_description: "メモ・詳細",
  personal_plan_submit: "完了",

  // event post
  event_post_date: "イベント開催日：",

  event_cancel_details_canceled: "イベントの中止が完了したため、イベントカレンダーからイベントが削除されました。",
  event_cancel_details_confirm_cancel: "イベントを中止してよろしいですか？有料イベントの場合は参加費が返金されます。",
  event_cancel_details_members_and_amount: "イベント申込者と参加費金額",
  event_number_of_members: "イベント申込者数：{0}人",
  event_refund_amount_sum: "返金額合計：{0}円",

  event_post_detail_see_to_group_top: "グループトップへ",
  event_post_detail_see_only_group_member: "イベントはグループメンバーのみお申し込みが可能です。\n　\nグループのトップページからグループに参加をお願いいたします。グループに参加完了後にこのイベントにお申込みいただけます。\n　\nグループよっては参加できない場合があります。",
  files: "添付ファイル",
  event_participant_setting: "イベント項目",
  event_post_detail_see_subject: "項目 : {0}",
  event_post_detail_see_capacity: "参加募集人数 : {0}",
  event_post_detail_see_fee: "参加料金 : {0}",
  qualification: "このイベントに参加できる人",
  event_post_detail_see_group_member_can_join: "グループメンバーのみ参加できます。メンバーではない方は、グループへの参加が完了しましたらお申込みできます。",
  about_cancel: "キャンセルについて",
  event_post_detail_see_payment_method_is_mebuku_pay: "お支払い方法は「めぶくPay」です。",
  event_post_detail_see_expiry_date: "投票終了日 : {0}",
  event_post_detail_see_edit_cancel: "編集/キャンセル",

  event_application_payment_applied: "イベントの申し込みが完了しました。",
  event_application_payment_persons_sum: "合計人数 : ",
  event_application_payment_fee_sum: "合計料金 : ",
  event_application_payment_payment_method_is_mebuku_pay: "※お支払い方法は「めぶくPay」です。めぶくPayのご登録を済ませてからお申し込みください。",
  event_application_payment_check_balance: "※お申し込み前に「めぶくPay」に残高があるかご確認ください。",
  event_application_payment_confirm: "この内容で間違いありません。",

  confirm_application: "申込内容を確認する",

  event_payment_details_pending_message: "イベントキャンセル、参加費返金リクエストをお送りしました。参加費の返金が完了するとイベントキャンセルが完了になります。\n参加費が返金されるまでしばらくお待ちください。",
  event_payment_details_canceled_message: "申し込みをキャンセルしました。",
  event_payment_details_confirm_cancel: "イベントの申し込みをキャンセルしますか？",
  event_payment_details_confirm_refund: "イベント参加費を返金します。",
  event_payment_details: "参加イベント詳細",
  host: "主催者",
  event_date: "開催日",
  event_payment_details_application_subject: "【参加項目】",
  subject: "項目",
  entry_fee: "参加料",
  per_person: "1名:",
  number_of_entering_person: "申し込み人数",
  event_payment_details_sum_of_entry_fee: "合計料金",
  required_amount: "お支払い金額",
  applier: "【お申し込み者】",
  change_number_of_entering_person: "【人数を変更する】",
  event_payment_details_cannot_change_number_of_persons: "大変申し訳ございませんが、人数を変更することはできません。\n一度キャンセルし、再度お申し込みください。",
  event_payment_details_description_of_cancel_1: "下記ボタンからキャンセルを行えます。",
  event_payment_details_description_of_cancel_2: "キャンセル後はいかなる場合でもキャンセルの取り消しは行えません。改めてお申し込みください。",
  about_cancel_fee: "【キャンセル料について】",
  cancel_pending: "キャンセル保留中",
  refund_entry_fee: "参加費を返金する",
  execute_cancel: "キャンセルする",

  // member group cancel membership onself
  group_cancel_membership_onself_description: "このグループを退会する場合は、以下の注意事項を確認し、チェックをしてください。",
  group_cancel_membership_onself_checkbox_1: "退会すると、マイページにグループが表示されなくなります。グループからの通知も届かなくなります。",
  group_cancel_membership_onself_checkbox_2: "公開グループの場合はグループ内の投稿・グループ内のプライベート投稿の閲覧ができなくなり、非公開グループの場合はすべての投稿が閲覧できなくなります。",
  group_cancel_membership_onself_checkbox_3: "グループメンバー全員のグループチャットの閲覧ができなくなります。",
  group_cancel_membership_onself_checkbox_4: "このグループに支払うことができなくなります。",
  group_cancel_membership_onself_submit: "グループを退会する",
  group_cancel_membership_onself_modal_description: "グループを退会しました。",
  group_cancel_membership_onself_error_1: "現在、グループを退会することができません。グループを退会するためには以下の条件を満たす必要があります。",
  group_cancel_membership_onself_error_2: "・これから開催されるイベントに申し込みをしていないこと",
  group_cancel_membership_onself_error_3: "・イベントキャンセルの返金が全て完了していること",
  group_cancel_membership_onself_error_4: "・立て替え精算の申請がされていないこと",

  // member group force cancel membership
  group_cancel_membership_description: "このユーザーを強制退会させる場合は、以下の注意事項を確認し、チェックをしてください。",
  group_cancel_membership_checkbox_1: "退会させると、メンバー一覧から削除されます。",
  group_cancel_membership_checkbox_2: "このユーザーにグループから送金することができなくなります。",
  group_cancel_membership_checkbox_3: "このユーザーにプライベート投稿ができなくなります。",
  group_cancel_membership_checkbox_4: "一度退会させると、元に戻すことができません。",
  group_cancel_membership_submit: "強制退会させる",
  group_cancel_membership_modal_description: "強制退会が完了しました。",
  group_cancel_membership_error_1: "現在、ユーザーを退会させることができません。強制退会をするためには以下の条件を満たす必要があります。",
  group_cancel_membership_error_2: "・ユーザーがこれから開催されるイベントに申し込みをしていないこと",
  group_cancel_membership_error_3: "・ユーザーに対してイベントキャンセルの返金が全て完了していること",
  group_cancel_membership_error_4: "・ユーザーの立て替え精算申請が残っていないこと",

  // member group close
  group_close_details_description: "グループを閉じる場合は、以下の注意事項を確認し、チェックをしてください。",
  group_close_details_checkbox_1: "グループを閉じる前に立て替え申請の申請漏れがないかメンバーに確認してください。",
  group_close_details_checkbox_2: "メンバーにグループを閉じる旨のお知らせをしてからグループを閉じてください。",
  group_close_details_checkbox_3: "グループを閉じると復元できません。",
  group_close_details_checkbox_4: "グループを閉じるとマイページからグループが削除されます。検索結果にも表示されません。",
  group_close_details_checkbox_5: "却下された申請がありますが、グループを閉じることに同意します。",
  close_group: "グループを閉じる",
  group_close_details_confirmation: "グループを閉じます。\n本当によろしいですか？",
  group_close_details_modal_description: "グループを閉じました。",
  group_close_error_1: "現在、グループを閉じることができません。グループを閉じるためには以下の条件を満たす必要があります。",
  group_close_error_2: "・立て替え精算が申請されていないこと",
  group_close_error_3: "・未開催または開催中のイベントがないこと",
  group_close_error_4: "・イベントキャンセルの返金が全て完了していること",
  group_close_error_5: "・グループウォレットの残高が0円であること",

  // member group top
  group_top_succeeded_in_applying: "申し込みが完了しました。\nグループ管理者が承認するまでお待ちください。\n 場合によっては参加ができない場合もございます。",
  group_top_joining_fee_is_necessary: "グループの参加には入会金が必要になります。",
  group_top_succeeded_in_joining: "参加が完了しました。\nマイページのグループから確認してください。",
  role_notice: "あなたはこのグループの「{0}」です。",
  is_blocking: "ブロック中",
  group_top_edit: "編集する",
  group_top_group_type_notice: "このグループは{0}グループです。",
  group_top_private: "非公開",
  group_top_public: "公開",
  group_top_event_calendar: "イベントカレンダー",
  group_content: "グループの主な活動内容",
  group_url: "WEBサイトなどのURL",
  joining_description: "グループへの参加について",
  joining_description_anyone: "このグループは誰でも参加できます。",
  joining_description_invitation: "このグループは招待されたユーザーのみ参加できます。",
  joining_description_approval: "このグループに参加するには承認が必要です。",
  joining_description_name: "氏名の提供が必要です。",
  fee_description: "会費について",
  group_top_fee_amount: "団体参加費：",
  group_top_monthly_fee_description: "このグループは月会費があります。",
  group_top_yearly_fee_description: "このグループは年会費がかかります。",
  group_top_monthly_fee: "月会費：",
  group_top_yearly_fee: "年会費：",
  group_top_no_joining_fee: "このグループに会費はありません。",
  group_top_detail: "グループ詳細",
  group_top_group_name: "団体名",
  membership_fee: "会費",
  group_top_fee_true: "あり",
  group_top_fee_false: "なし",
  number_of_member: "メンバー数",
  number_of_post: "投稿数",
  join_group: "グループに参加する",

  // group owner setting page
  group_page_no_fee: "月会費/年会費の徴収がないため、\n支払い状況はありません。",
  group_page_member_group: "グループページ",
  group_page_group_top: "グループトップ",
  group_page_member: "メンバー管理",
  member_list: "メンバー一覧",
  group_page_member_invite: "メンバーを招待する",
  group_page_balance: "グループの「めぶくPay」残高：{0}円",
  group_page_pay_to_member: "メンバーに送金する",
  group_page_pay_to_shop: "店舗にて支払う",
  payment_status: "支払い状況",
  event_cancel_settlement: "イベントキャンセルの精算",
  group_page_calendar: "カレンダー",
  group_page_event_calendar: "イベントカレンダーを見る",
  group_page_other: "そのほか",
  group_page_drop_out_group: "グループから脱退する",

  group_roles_member_is_not_found: "メンバーが見つかりませんでした。",
  group_roles_role_is_changed: "権限の変更が完了しました。",
  leader_description: "グループ内のすべての機能を使用できます。リーダーの変更、グループの脱退はできません。",
  subleader_description: "グループトップページの修正以外、グループ内のすべての機能を使用できます。",
  finance_description: "主にお支払い関係の機能を使用できます。",
  no_role: "役割なし",
  no_role_description: "一般のユーザーとなります。",
  role: "役割",
  role_updated_date: "権限付与日",

  // create group
  create_group_lack_of_required_item: "＊未入力の項目があります。",
  create_group_title: "グループを作る",
  group_name: "グループ名",
  create_group_icon: "グループアイコン",
  create_group_select_image: "画像を選ぶ",
  create_group_private_setting: "グループ公開設定",
  create_group_public: "公開にする",
  create_group_public_description: "めぶくコミュニティの全員が閲覧可能なグループです。",
  create_group_private: "非公開にする",
  create_group_private_description: "招待されたユーザーのみ閲覧可能なグループです。",

  create_group_pii_description: "グループに参加するメンバーの氏名をメンバーリストに表示するかを設定できます。なお、リーダー・サプリーダー・会計メンバーの氏名は以下の設定に関係なく、グループメンバーに表示されます。メンバーの氏名は、リーダーとサブリーダーのみが問覧できます。",
  create_group_pii_no: "メンバーのニックネームのみ表示する。",
  create_group_pii_yes: "メンバーのニックネームと氏名を表示する。",

  create_group_main_image: "メイン画像",
  create_group_description: "このグループの説明",
  create_group_entry_anyone_description: "承認なしで誰でもグループに参加できるようになります。",
  create_group_entry_approval_required_description: "「グループ参加承待ち」リストに参加リクエストが届きます。承認されたメンバーのみグループに参加できます。",
  create_group_entry_invitation_required_description: "非公開グループのため、このグループは検索しても表示されません。 招待されたユーザーのみ参加できます。",
  create_group_joining_fee_title: "入会金があります。",
  create_group_joining_fee_description: "ONにすると金額を設定できます。入会費はグループ参加時に支払いになります。",
  create_group_regular_fee_title: "月額費または年会費があります。",
  create_group_regular_fee_description: "ONにすると料金を設定できます。",
  create_group_fee_set_amount: "金額を設定します。",
  monthly_fee: "月会費",
  yearly_fee: "年会費",
  create_group_fee_method_to_pay: "グループメンバーは、マイページのお支払い関係から会費をお支払いできます。",
  create_group_fee_notice: "注意：自動引き落とし機能はありません。",
  create_group_fee_payment_description: "メモ欄",
  check: "確認する",

  // disclosure
  confirm_terms_of_service: "上記の注意事項を確認し、すべての事項に同意いたします。",
  agree_with_disclosure: "上記の内容を確認し、全ての内容に同意します。",

  // pii view info
  pii_title: "個人情報の提供",
  pii_nickname: "ニックネーム：",
  pii_name: "氏名：",
  pii_confirmation: "このグループは氏名の提供を求めています。同意しますか？",

  // member list
  member_list_approved_member_list: "グループメンバー全員　{0}人",
  member_list_pending_member_list: "グループ参加承認待ち　{0}人",
  member_list_event_users: "参加者確定のイベントメンバー",
  member_list_finished_event: "終了したイベント",
  member_list_cancelled: "キャンセル済み",
  refund_pending: "返金保留",

  member_list_approved: "グループへの参加を承認しました。",
  member_list_denied: "拒否しました。",
  member_list_confirm_approving_request: "参加リクエストを承認しますか?",
  member_list_confirm_denying_request: "このユーザーのグループ参加を拒否します。\nよろしいですか?",

  // event users
  event_users_refunded: "イベント参加費の返金が完了しました。",
  event_users_event_users: "イベント参加者:",
  event_users_amount_sum: "合計金額:　{0}円",
  event_users_confirm_refunding: "返金しますか?",
  pay: "支払う",
  event_users_participant_settings_persons: "名様",

  // group invitation
  group_invite_placeholder: "グループリンク...",

  link_copied: "リンクをコピーしました",
  invitation_link_creations_invited: "ユーザーを招待しました。\n　\nユーザーのマイページにこのグループが表示されるようになりました。",
  invitation_link_creations_invite_to_group: "グループへ招待する",
  invitation_link_creations_invitation_qr: "QRコード",
  invitation_link_creations_invitation_qr_description: "メンバーになってもらいたい人に「めぶくアプリ」のパスポートから、下記QRコードを読み込んでもらいます。読み込み後メンバーとなります。",
  invitation_link_creations_send_invitation_link: "招待リンクを送る",
  invitation_link_creations_invitation_link_description: "下記ボタンをクリックすると、招待リンクがコピーされますので、メールやSNS等にペーストしてメンバーになってもらいたい人宛に送ってください。マイページから招待リンクを入力するとグループトップページが表示されます。ユーザーが「参加する」ボタンを押した後、参加を承認されると参加が完了します。",
  invitation_link_creations_copy_invitation_link: "招待リンクをコピー",
  invitation_link_creations_search: "検索する",
  invitation_link_creations_is_already_invited_or_member: "すでにグループのメンバーまたは招待されている",
  invitation_link_creations_send_invitation: "招待を送信",
  invitation_link_creations_search_user: "ユーザーを検索する",

  // block unblock
  blocked: "ブロックしました。",
  unblocked: "ブロックを解除しました。",
  confirm_block: "ブロックしますか？",
  confirm_unblock: "ブロックを解除しますか？",
  block_notice:
    "ブロックすると、今後このユーザーまたはグループの投稿、チャット、プライベート投稿の内容は表示されません。\nブロックの解除はユーザーを検索して行えます。",
  unblock_notice:
    "ブロックを解除すると、\nこのユーザーまたはグループの投稿、チャット、プライベート投稿の内容は表示されます。",

  // payment
  payee: "お支払い先のユーザー",
  payment_required_to_join_group: "本グループの参加には入会金が必要なため、めぶくPayでの入会金の支払いをお願いいたします。\n支払いが完了すると、グループに参加できます。",
  payment_paid_joining_fee: "入会金のお支払いありがとうございました。グループへの参加が完了しました。\nマイページからグループを確認してください。",
  payment_paid_to_group: "送金しました。",
  payment_other_error: "その他考えられそうな文言 \n・残高不足のため送金できませんでした。めぶくPayでチャージ後あたらめてお申し込みください。\n・エラー \n・お申し込み済みです。",
  payment_joining_fee: "入会費",
  payment_monthly_fee_is_already_paid: "今月分は支払い済みです。",
  payment_yearly_fee_is_already_paid: "今年分は支払い済みです。",
  payment_address: "お支払い先",
  select_group: "グループを選ぶ",
  payment_type: "種別",
  payment_amount: "金額",
  payment_balance: "ユーザー「めぶくPay」残高：{0}円",
  payment_details: "メモ",
  payment_checklist_1: "お支払い後、即時めぶくPayより指定の金額が支払われます。",
  payment_checklist_2: "お支払い後の払い戻しはできません。",
  payment_checklist_3: "注意事項を確認しました。",
  payment_transfer_money: "送金する",
  payment_store_payment: "店舗支払い",
  payment_reimbursement: "立替精算",
  payment_payer: "送信元",
  payment_payee: "送金先",
  payment_payment_date: "支払い日",
  payment_payee_nickname: "支払い先",
  payment_payment_amount: "支払い金額",
  payment_method: "支払い方法",
  payment_mabuku_pay: "めぶくPay",
  payment_transaction_id: "取引ID",
  payment_income: "収入",
  payment_expense: "支出",
  payment_history: "利用履歴",
  payment_payment_month: "利用月",
  year: "年",
  month: "月",
  display: "表示する",

  group_user_payment_select_group_member: "グループメンバーを選ぶ",
  group_user_payment_select_event_member: "イベントメンバーを選ぶ",
  group_user_payment_event_fee: "イベント費",
  payment_history_type: "種類",

  scan_qr_error: "無効なQRコードです。有効なPokepay請求書のQRをスキャンしてください。",
  scan_qr_read_code: "お店のQRコードを読み込んでください。",
  scan_qr_trademark: "QRコードは(株)デンソーウェーブの登録商標です",

  payment_review_paid: "お支払いが完了しました",
  payment_review_confirm_with_clerk: "お店の方に画面を見せてください。\n了承が取れましたらお支払いください。",
  payment_review_change_amount: "金額を変更する",

  member_payment_months: "月分",

  cancel_request_pending_event: "キャンセル待ちのイベント",
  cancel_request_date: "申請日：{0}",
  mebuku_pay_hitory: "めぶくPay 利用履歴",

  input_amount: "支払い金額を入力する",

  // reimbursement
  reimbursement: "立て替え精算",
  reimbursement_payment_date: "お支払い日",
  reimbursement_image: "書類",
  reimbursement_succeed_in_create: "立て替え申請を送りました。",
  reimbursement_content: "立て替え内容：支払日、支払い先、金額",
  reimbursement_image_description1: "現金、電子マネークレジットカードなどでお支払いしたものを立て替えた場合",
  reimbursement_image_description2: "レシートなど、お支払い情報が記載されている書類をアップロードし、金額、お支払い先、お支払日を入力してください。",
  reimbursement_upload_image: "書類をアップロードする",
  day: "日",
  reimbursement_payment_address_example: "〇〇スーパーマーケット",
  reimbursement_details_example: "例：X月X日にBBQをした時の食材代です。",
  reimbursement_check1: "請求先と立て替え内容は合っています。",
  reimbursement_check2: "料金の振込先はめぶくPayになります。",
  reimbursement_submit: "立て替え申請を送る",
  reimbursement_succeed_in_reject: "立て替え申請を却下しました。",
  reimbursement_demand_address: "請求先",
  reimbursement_applier: "申請者",
  reimbursement_payment_method: "お支払い方法",
  reimbursement_created_at: "申請日",
  reimbursement_id: "申請ID",
  reimbursement_status: "ステータス",
  reimbursement_updated_at: "立て替え完了日",
  reimbursement_reject_reason: "却下理由",
  reimbursement_submit_reject: "送る",
  reimbursement_approved: "精算済み",
  reimbursement_rejected: "却下",
  reimbursement_pending: "精算待ち",
  reimbursement_history: "立て替え申請履歴",
  reimbursement_settle: "精算する",
  reimbursement_reject: "却下する",
  reimbursement_approve_message: "立て替え精算の申請金額を送金します。",
  reimbursement_succeed_in_approve: "立て替え精算の承認が完了しました。",
  reimbursement_created_at_month: "申請月",
  reimbursement_reason: "理由",

  //chat
  group_chat_list_static_option: "グループチャット",
  group_chat_list_add_to_group_chat: "グループチャットに追加する",

  chat_users_confirmation_to_delete: "このユーザーをチャットから削除してもよろしいですか？",
  chat_users_confirmation_to_leave: "このチャットから退出しますか？一度退出するとチャットの履歴は確認できなくなります。",
  chat_users_left: "退出しました。",
  chat_users_title: "チャット参加メンバー",
  chat_users_leave: "退出する",
  chat_users_delete: "削除する",

  user_chat_mambers: "参加メンバー",
  user_chat_added: "追加しました。",

  failed_to_create_chat: "チャットの作成に失敗しました",

  add_chat_user_list_title: "ユーザー検索",
  add_chat_user_list_not_found: "ユーザーが見つかりませんでした",

  ranking: "ランキング",

  user_action_top_10: "ユーザーアクション TOP 10",

  // dashboard
  dashboard: "ダッシュボード",
  dashboard_description: "ここはユーザーの投稿などをグラフ化し、視覚的にどのくらい使われているのかが見えるページです。",
  dashboard_suggestion: "「意見ひろば」のダッシュボード",
  dashboard_number_of_likes: "いいね数",
  dashboard_number_of_comments: "コメント数",
  dashboard_number_of_votes: "投票数",
  dashboard_note_of_opinion: "＊投稿は寄せられた意見を元にめぶくナビゲーターが行っています。",
  dashboard_post: "「みんなの投稿」のダッシュボード",

  // search screen
  search_how_to_search_user_or_group: "ユーザーとグループの検索は「＠」を先頭に入れる",
  search_not_found: "検索結果がありません",

  // intro page
  read_turorial: "使い方を見る",

  // error
  session_timeout: "セッションがタイムアウトしました。再度ログインしてください。",
  api_unknown_error: "通信時にエラーが発生しました。",
  include_ng_words: "投稿内容に使用できない言葉が含まれているようです。レビュー後に公開されます。",
  has_already_member_group: "作成できるグループは１つのみです。",
  required_name_to_join_member_group: "このグループへの参加には氏名の登録が必要です。",
  only_number_can_be_inputted: "数字のみ入力できます。",
  error_enter: "を入力してください。",
  error_select: "を選択してください。",
  error_set_value: "を設定してください。",
  error_date_before: "{0}には{1}以前を設定してください。",
  error_date_after: "{0}には{1}以降を設定してください。",
  error_upload: "をアップロードしてください。",
  error_file_extension: "のいずれかのファイルのみ選択可能です。",

  // error images
  error_get_file: "ファイルを取得できませんでした。",
  error_zero_file: "ファイルがゼロ件です。",
  error_file_size: "ファイルサイズが{0}MB/枚を超える{1}はアップロードできません。",
  error_image_extension: "のいずれかの画像のみ選択可能です。それ以外の画像には対応していません。",
  error_image_count: "画像は{0}枚まで選択可能です。{0}枚を超える画像は選択できません。",

  // Management screen
  mng_mebuku_community: "めぶくコミュニティ",
  mng_yes: "はい",
  mng_no: "いいえ",
  mng_decide: "決定",
  mng_cancel: "キャンセル",
  mng_refresh: "リフレッシュ",
  mng_create: "作成",
  mng_update: "更新",
  mng_save: "保存",
  mng_delete: "削除",
  mng_back: "戻る",
  mng_required: "（必須）",
  mng_optional: "（任意）",
  mng_dialog_confirmation_title: "実行してもよろしいですか？",
  mng_user_icon: "めぶくユーザー画像",
  mng_post_event: "イベント",
  mng_copied_success: "コピーしました。",
  mng_search_area_title: "検索フォーム",
  mng_search: "検索",
  mng_sort: "並び替え",
  mng_close: "閉じる",
  mng_confirm: "確定",
  mng_anonymous: "匿名",
  mng_approve: "承認",
  mng_reject: "拒否",
  mng_user: "ユーザー",
  mng_member_group: "グループ",
  mng_other: "その他",
  mng_unit_yen: "円",
  mng_unit_person: "人",
  mng_mebuku_pay: "めぶくPay",
  mng_all: "すべて",
  mng_confirm_approve: "この投稿を承諾してもよろしいですか？この操作は取り消すことができません。",
  mng_confirm_reject: "この投稿を拒否してもよろしいですか？この操作は取り消すことができません。",

  mng_session_timeout: "セッションがタイムアウトしました。再度ログインしてください。",

  /* ログインページ */
  mng_management_user_login: "管理者ログイン",
  mng_user_name: "ユーザー名",
  mng_login: "ログイン",

  mng_login_email_and_password_is_required: "Eメールとパスワードを入力してください。",

  /* メニュー */
  mng_title: "管理画面",
  mng_menu: "メニュー",
  mng_dashboard: "ダッシュボード",
  mng_dashboard_statistics: "統計情報",
  mng_management_users: "ユーザー管理",
  mng_management_users_users: "管理ユーザー",
  mng_public_users: "めぶくユーザー管理",
  mng_public_users_account_suspension: "アカウント停止機能",
  mng_public_users_user_notifications: "ユーザーへの通知",
  mng_public_users_member_groups: "メンバーグループ",
  mng_data_definitions: "データ定義",
  mng_data_definitions_categories: "カテゴリー",
  mng_data_definitions_groups: "ジャンル",
  mng_data_definitions_sample_images: "サンプル画像",
  mng_negative_words: "NGワード管理",
  mng_negative_word_list: "NGワード",
  mng_negative_words_negative_words: "NGワード一覧",
  mng_negative_words_pending_posts: "審査中の投稿（NGワードを含んだ投稿）",
  mng_negative_words_rejected_posts: "拒否した投稿",
  mng_negative_words_pending_comments: "NGワードを含んだコメント",
  mng_negative_words_rejected_comments: "拒否したコメント",
  mng_shops: "店舗管理",
  mng_shops_qr_payment: "QR支払い対応店舗",
  mng_shops_event_notification: "イベントで通知する店舗",
  mng_money: "金銭管理",
  mng_money_payment: "めぶくPay取引管理",
  mng_posts: "投稿一覧",
  mng_posts_reported: "報告された投稿",
  mng_posts_everyone_posts: "みんなの投稿一覧",
  mng_posts_post_events: "イベント一覧",
  mng_navigator: "ナビゲーターメニュー",
  mng_navigator_suggestions: "一般ユーザーからの意見",
  mng_navigator_navigator_posts: "意見ひろばの投稿一覧",

  /* 統計情報 */
  mng_registration: "登録データ",
  mng_utilization: "活用データ",
  mng_target_date: "日付",
  mng_select_date: "日付の選択",
  mng_term: "期間",
  mng_term_separator: "～",
  mng_statistics_submit: "集計",
  mng_error_invalid_end_date: "終了日 には 開始日 以降の日付を設定してください。",
  mng_summary: "全体サマリー",
  mng_summary_registration_total_users: "総登録ユーザー数",
  mng_summary_registration_total_member_groups: "総登録グループ数",
  mng_summary_registration_new_users: "新規登録ユーザー数",
  mng_summary_registration_new_member_groups: "新規登録グループ数",
  mng_summary_registration_registered_personal_basic_info: "基本３情報提供に同意した総ユーザー数",
  mng_summary_utilization_users_posts: "ユーザー投稿数",
  mng_summary_utilization_posts_in_group: "グループ投稿数（グループ内投稿数）",
  mng_summary_utilization_private_posts_in_group: "グループ投稿数（グループ内プライベート投稿数）",
  mng_summary_utilization_groups_with_many_posts: "2回以上投稿しているグループ数",
  mng_statistics_users: "ユーザー",
  mng_users_utilization_generation__9: "～10歳",
  mng_users_utilization_generation_10_17: "10~17歳",
  mng_users_utilization_generation_18_19: "18~19歳",
  mng_users_utilization_generation_20_29: "20~29歳",
  mng_users_utilization_generation_30_39: "30~39歳",
  mng_users_utilization_generation_40_49: "40~49歳",
  mng_users_utilization_generation_50_59: "50~59歳",
  mng_users_utilization_generation_60_69: "60~69歳",
  mng_users_utilization_generation_70_79: "70~79歳",
  mng_users_utilization_generation_80_: "80歳～",
  mng_users_utilization_posts: "投稿数",
  mng_users_utilization_comments: "コメント数",
  mng_users_utilization_likes: "いいね数",
  mng_users_utilization_unit: "単位",
  mng_users_utilization_tags: "急上昇タグ",
  mng_statistics_no_post_tags: "対象期間中にタグが追加された投稿はありません",

  /* 管理ユーザー */
  mng_admin_user_super_admin: "スーパーアドミン",
  mng_admin_user_admin: "管理者",
  mng_admin_user_navigator: "ナビゲーター",
  mng_create_admin_user: "ユーザーを追加",
  mng_edit_admin_user: "ユーザーを編集",
  mng_admin_user_name: "名前",
  mng_admin_user_nickname: "ニックネーム",
  mng_admin_user_email: "Eメール",
  mng_admin_user_password: "パスワード",
  mng_admin_user_image_label: "アイコン設定",
  mng_admin_user_navigator_enabled: "有効",
  mng_admin_user_navigator_disabled: "無効",
  mng_admin_user_password_title: "パスワード（半角英数字のみ入力）",
  mng_create_admin_user_password_placeholder: "abcd1234",
  mng_edit_admin_user_password_placeholder: "パスワード変更時のみ入力してください。",
  mng_notice_change_password: "※パスワードが変更されます。",
  mng_confirmation_delete_admin_user: "この管理ユーザーを削除してもよろしいですか？",
  mng_error_name_blank: "名前を入力してください。",
  mng_error_nickname_blank: "ニックネームを入力してください。",
  mng_error_email_blank: "Eメールを入力してください。",
  mng_error_password_blank: "パスワードを入力してください。",
  mng_error_password_invalid_length: "パスワードには{0}文字以上入力してください。",
  mng_error_password_invalid_format: "半角で入力してください。",

  /* ユーザーへの通知 */
  mng_user_notifications_search_term: "期間",
  mng_user_notifications_search_query_placeholder: "送信した通知、または、送信先のユーザーを検索できます。",
  mng_user_notifications_search_query_note: "ユーザーの検索は「＠」を先頭に入れます。",
  mng_user_notifications_data_title: "通知履歴",
  mng_user_notifications_sort_asc: "昇順",
  mng_user_notifications_sort_desc: "降順",
  mng_user_notifications_details: "通知詳細",
  mng_user_notifications_send_success: "通知を送りました。",

  mng_user_notifications_send: "通知を送る",
  mng_user_notifications_message_to: "送信先",
  mng_user_notifications_message_sent_date: "送信日",
  mng_user_notifications_message_title: "タイトル",
  mng_user_notifications_message_summary: "概要",
  mng_user_notifications_message_details: "詳細",

  /* メンバーグループ */
  mng_member_groups_search_query_placeholder: "メンバーグループ名を検索できます。",
  mng_member_groups_data_title: "メンバーグループ一覧",
  mng_member_groups_sort_asc: "昇順",
  mng_member_groups_sort_desc: "降順",
  mng_member_groups_details: "メンバーグループ詳細",
  mng_member_groups_name: "メンバーグループ名",
  mng_member_groups_banner_image: "メイン画像",
  mng_member_groups_private_setting: "グループ公開設定",
  mng_member_groups_private_setting_public: "公開",
  mng_member_groups_private_setting_private: "非公開",
  mng_member_groups_pii_needed: "名前の表示方法",
  mng_member_groups_pii_needed_true: "メンバーのニックネームと氏名を表示する",
  mng_member_groups_pii_needed_false: "メンバーのニックネームのみ表示する",
  mng_member_groups_description: "説明",
  mng_member_groups_activities: "主な活動内容",
  mng_member_groups_social_links: "WEBサイトなどのURL",
  mng_member_groups_approval_required: "参加条件",
  mng_member_groups_approval_required_true: "このグループに参加するには承認が必要です。",
  mng_member_groups_approval_required_false: "このグループは招待されたユーザーのみ参加できます",
  mng_member_groups_fee: "会費",
  mng_member_groups_fee_free: "なし",
  mng_member_groups_fee_joining: "入会金",
  mng_member_groups_fee_joining_value: "{0}円",
  mng_member_groups_fee_monthly: "月会費 {0}円",
  mng_member_groups_fee_yearly: "年会費 {0}円",
  mng_member_groups_fee_explanation: "メモ欄",
  mng_member_groups_posts_count: "投稿数",
  mng_member_groups_digital_id: "デジタルID",
  mng_member_groups_users: "メンバー",
  mng_member_groups_users_csv: "CSV出力",
  mng_member_groups_users_count: "メンバー数",
  mng_member_groups_users_leader: "リーダー",
  mng_member_groups_users_subleader: "サブリーダー",
  mng_member_groups_users_finance: "会計",
  mng_member_groups_users_fail_output_csv: "CSV出力に失敗しました。",

  /* ジャンル */
  mng_group: "ジャンル",
  mng_group_name: "ジャンル名",
  mng_add_group: "ジャンル作成",
  mng_create_group: "ジャンル作成",
  mng_create_group_button: "ジャンルを追加",
  mng_edit_group: "ジャンルを編集",
  mng_group_delete_confirmation_message: "選択したジャンルを削除しますか？",
  mng_group_post_count: "投稿数：{0}",
  mng_group_placeholder: "ジャンル名",

  /* カテゴリー */
  mng_category_posts_count: "投稿数：{0}",

  /* サンプル画像の管理 */
  mng_sample_images_search_term: "ファイル名（部分一致）",
  mng_sample_images_sort_by_name_asc: "ファイル名の昇順",
  mng_sample_images_sort_by_name_desc: "ファイル名の降順",
  mng_sample_images_used: "使用中",
  mng_sample_images_create: "サンプル画像を追加",
  mng_sample_images_update: "サンプル画像を更新",
  mng_sample_images_update_error: "処理に失敗しました。本画面をリロードして再試行してください。",
  mng_sample_images_alt: "設定されているサンプル画像",
  mng_sample_images_drag_and_drop: "画像をドラッグ＆ドロップ",
  mng_sample_images_select_file: "画像を選択",
  mng_sample_images_updated_at: "更新",
  mng_sample_images_delete_confirmation_message: "選択したサンプル画像を削除しますか？",

  /* NGワード一覧 */
  mng_search_negative_words_placeholder: "NGワードを検索できます。",
  mng_negative_word_word: "ワード",
  mng_create_negative_word_form_title: "NGワードの作成",
  mng_create_negative_word: "NGワード作成",
  mng_create_negative_word_button: "NGワードを追加",
  mng_delete_negative_word_confirmation_message: "選択したNGワードを削除しますか？",
  mng_error_required_negative_word: "ワードを入力してください。",

  /* NGワードを含んだ投稿 */
  mng_posts_count: "投稿",
  mng_details: "本文",
  mng_post_created_at: "投稿日",
  mng_post_author: "オーサー",

  /* 審査中の投稿 */
  mng_pending_posts_approve: "承認する",
  mng_pending_posts_reject: "拒否する",
  mng_pending_posts_approve_success: "投稿を承認しました。",
  mng_pending_posts_reject_success: "投稿を拒否しました。",

  /* 拒否した投稿 */
  mng_rejected_posts_search_query_placeholder: "投稿、イベント投稿、報告理由を検索できます。",
  mng_rejected_posts_search_query_note: "タグの検索は「＃」を先頭に入れます。",
  mng_rejected_posts_sort_by_new: "投稿日が新しい順",
  mng_rejected_posts_sort_by_old: "投稿日が古い順",
  mng_rejected_posts_report_reasons: "報告理由",

  /* NGワードを含んだコメント */
  mng_comments_count: "コメント",

  /* めぶくPay取引管理 */
  mng_payment_detail: "支払明細",
  mng_payment_type: "種別",
  mng_payment_payer_info: "支払元",
  mng_payment_payer_type: "支払元種別",
  mng_payment_payer_name_title: "支払元{0}名",
  mng_payment_digital_id: "デジタルID",
  mng_payment_payee_info: "送金先",
  mng_payment_payee_type: "送金先種別",
  mng_payment_payee_name_title: "送金先{0}名",
  mng_payment_amount: "金額",
  mng_payment_details: "支払い時メモ",
  mng_reimbursement_detail: "立て替え詳細",
  mng_reimbursement_payment_date: "支払日",
  mng_reimbursement_payment_address: "支払先",
  mng_payment_transaction_id: "決済番号",
  mng_payment_date: "決済日",
  mng_payment_input_form_placeholder: "決済番号を入力してください",
  mng_payment_person_type_user: "ユーザー",
  mng_payment_person_type_membergroup: "グループ",
  mng_payment_person_type_shop: "店舗",
  mng_payment_type_: "店舗",
  mng_payment_type_joining_fee: "入会金",
  mng_payment_type_event_fee: "イベント費",
  mng_payment_type_storepayment: "店舗支払い",
  mng_payment_type_reimbursement: "立替精算",
  mng_payment_type_other_fee: "その他",
  mng_payment_type_membership_fee: "グループ会費",
  mng_filtered_payments: "絞り込み検索",
  mng_payment_date_term: "決済期間",
  mng_payments_search_transaction_id: "決済番号検索",
  mng_payments_sort_asc: "昇順",
  mng_payments_sort_desc: "降順",
  mng_payments_filtered_reset: "リセット",

  // opinion_post
  mng_navigator_posts: "意見ひろば一覧",
  mng_search_navigator_posts_placeholder: "意見ひろばの投稿を検索できます。",
  mng_navigator_posts_fetch_vote: "投票絞込",
  mng_create_new_opinion_post: "新規で投稿する",
  mng_create_new_opinion_post_from_suggestion: "この意見を投稿する",
  mng_can_view_post_user: "この投稿を見られるユーザー",
  mng_can_view_post_user_count: "この投稿を見られるユーザー：{0}名",
  mng_view_users: "ユーザーを見る",
  mng_post_comment: "コメント",
  mng_add_post_private_user: "ユーザーを追加する",
  mng_success_add_post_private_user: "ユーザーを追加しました。",
  mng_faild_add_post_private_user: "ユーザーを追加できませんでした。",
  mng_success_delete_post_private_user: "ユーザーを削除しました。",
  mng_faild_delete_post_private_user: "ユーザーを削除できません。",
  mng_confirmation_delete_post_private_user: "この投稿を見られるユーザーを削除しますか？",
  mng_add_post_private_user_desc: "ユーザーを検索できます。",
  mng_search_users_label: "ユーザーを検索",
  mng_post_like_count: "いいね！{0}件",
  mng_post_vote_status: "投票状況",
  mng_post_comment_count: "コメント{0}件を読む",

  // everyone_posts
  mng_search_everyone_posts_placeholder: "みんなの投稿を検索できます。",
  mng_category: "カテゴリー",

  // イベント一覧
  mng_search_event_term: "イベント開催期間",
  mng_event_term_all: "すべて",
  mng_search_navigator_events_placeholder: "イベント投稿を検索できます。",

  // 投稿
  mng_post_attachments: "添付ファイル",
  mng_event_venue: "会場",
  mng_event_application_users_count: "参加者数",
  mng_event_date: "開催日",
  mng_event_url: "WebサイトのURL",
  mng_event_application_term: "募集期間",
  mng_event_applications: "申込項目",
  mng_event_application_name: "項目",
  mng_event_application_nop: "募集人数",
  mng_event_application_amount: "料金",
  mng_event_can_participate: "参加できる人",
  mng_event_about_cancel: "キャンセルについて",
  mng_event_how_payment: "支払い方法",
  mng_event_participation_status: "参加状況",
  mng_see_more: "続きを読む",
  mng_see_less: "表示を少なくする",
  mng_report: "報告する",
  mng_event_detail: "イベント詳細",
  mng_report_success: "報告しました。",
  mng_report_reason_label: "この投稿を報告する理由を教えてください。",
  mng_report_placeholder: "差し支えなければ通報する理由をお書きください",
  mng_post_creator: "投稿者",

  // 管理画面 投稿作成
  mng_private_post: "プライベート投稿",
  mng_post_title: "タイトル",

};
